var exports = {
  "JC": "UserProfilePopout.module__role___WmtjNk",
  "s$": "UserProfilePopout.module__roleRemoveIcon___WmtjNk",
  "Bx": "UserProfilePopout.module__iconSmall___WmtjNk",
  "bc": "UserProfilePopout.module__profileCustomStatus___WmtjNk",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___WmtjNk",
  "ZB": "UserProfilePopout.module__profileDisplayName___WmtjNk",
  "yn": "UserProfilePopout.module__profileDataWarning___WmtjNk",
  "zF": "UserProfilePopout.module__profilePopoutCard___WmtjNk",
};

module.exports = exports;
